/**
 * Builds a table of contents from h2 headings in article content and inserts it before the first h2.
 */
(function () {
  function slugify(text) {
    return text
      .trim()
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function buildTableOfContents(contentEl) {
    var headings = contentEl.querySelectorAll('h2');
    if (!headings.length) return;

    var toc = document.createElement('nav');
    toc.id = 'table-of-contents';
    toc.setAttribute('aria-labelledby', 'table-of-contents-heading');

    var title = document.createElement('h2');
    title.id = 'table-of-contents-heading';
    title.className = 'table-of-contents__title';
    title.textContent = 'Table of Contents';
    toc.appendChild(title);

    var list = document.createElement('ul');
    var usedIds = {};

    headings.forEach(function (heading, index) {
      var text = heading.textContent.trim();
      if (!text) return;

      var id = heading.id || slugify(text) || 'section-' + (index + 1);
      while (usedIds[id]) {
        id = id + '-' + (index + 1);
      }
      usedIds[id] = true;
      heading.id = id;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.appendChild(list);
    headings[0].insertAdjacentElement('beforebegin', toc);
  }

  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content || content.querySelector('#table-of-contents')) return;
    buildTableOfContents(content);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
